import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_AdminvatgroupListComponent from "../components/_FM_adminvatgroup/_FM_AdminvatgroupListComponent";
import _FM_AdminvatgroupFormComponent from "../components/_FM_adminvatgroup/_FM_AdminvatgroupFormComponent";
import _FM_AdminvatgroupShowComponent from "../components/_FM_adminvatgroup/_FM_AdminvatgroupShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_AdminvatgroupPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('currencies') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/admin-vatgroup')
  }, []);

  return (
    <div className="_FM_VatgroupPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/admin-vatgroup"}/>
      <Panel>
        <_FM_AdminvatgroupListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/admin-vatgroup');
               }}>
        <_FM_AdminvatgroupFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/admin-vatgroup');
               }}>
        <_FM_AdminvatgroupShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_AdminvatgroupPage);
